import { css } from 'styled-components';
import type { StyledHeaderTabsListItemProps } from '../types';

function isActiveStyle({ $isActive = false }: StyledHeaderTabsListItemProps) {
  if ($isActive) {
    return css<StyledHeaderTabsListItemProps>`
      font-weight: 700;
    `;
  }
}

export default function settingsListItemStyle({ $isSettingsListItemStyle = false }: StyledHeaderTabsListItemProps) {
  if ($isSettingsListItemStyle) {
    return css<StyledHeaderTabsListItemProps>`
      padding: 1.2rem 1.5rem;
      text-align: left;
      ${isActiveStyle}
    `;
  }
}
